import { render, staticRenderFns } from "./goodsList.vue?vue&type=template&id=37d067e7&scoped=true&"
import script from "./goodsList.vue?vue&type=script&lang=js&"
export * from "./goodsList.vue?vue&type=script&lang=js&"
import style0 from "./goodsList.vue?vue&type=style&index=0&id=37d067e7&lang=scss&scoped=true&"
import style1 from "./goodsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d067e7",
  null
  
)

component.options.__file = "goodsList.vue"
export default component.exports